import type { SVGProps } from 'react';
const SvgStackedBarChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#stacked_bar_chart_svg__a)">
      <path
        fill="currentColor"
        d="M6 10h3v10H6V10Zm0-5h3v4H6V5Zm10 11h3v4h-3v-4Zm0-3h3v2h-3v-2Zm-5 0h3v7h-3v-7Zm0-4h3v3h-3V9Z"
      />
    </g>
    <defs>
      <clipPath id="stacked_bar_chart_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStackedBarChart;
